import React, { MouseEvent } from 'react';
import { CategoryCard, CategoryCardHeader, CategoryCardMedia } from 'common/components';
import { ProductCategoryCards } from 'common/components/pdp';
import { enhanceImageUrl } from 'utils';
import { analyticsUtils } from 'utils/analytics-utils';
import { KITCHEN_PDP_ELEMENT_BLOCK } from '../../kitchen-pdp-constants';
import { CATEGORY_CARD_LIST } from './category-card-section-constants';

type CategoryCardSectionProps = {
  productId: string;
};

export const CategoryCardSection = ({ productId }: CategoryCardSectionProps) => {
  const handleCardClick = (cardName: string) => () => {
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: `${KITCHEN_PDP_ELEMENT_BLOCK} / other`,
      elementName: 'Вам могут пригодиться',
      elementText: cardName,
      komplektyId: productId,
    });
  };

  const handleCardWheelClick = (e: MouseEvent, cardName: string) => {
    if (e.button === 1) {
      handleCardClick(cardName)();
    }
  };

  return (
    <ProductCategoryCards
      cardList={CATEGORY_CARD_LIST}
      renderCard={({ name, link, imgSrc }) => (
        <CategoryCard
          /* @ts-expect-error: param typecheck error */
          onAuxClick={e => handleCardWheelClick(e, name)}
          onClick={handleCardClick(name)}
          {...link}>
          <CategoryCardHeader adaptive={false} title={name} />
          <CategoryCardMedia alt="" height={140} loading="lazy" src={enhanceImageUrl(imgSrc)} width={156} />
        </CategoryCard>
      )}
    />
  );
};
